module.exports = __webpack_public_path__ + "prod/20261104151832/img/logo.1444e71b.png";